// src/supabaseClient.js
import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  // eslint-disable-next-line no-console
  console.warn("⚠️ Missing Supabase env vars:", {
    REACT_APP_SUPABASE_URL: Boolean(supabaseUrl),
    REACT_APP_SUPABASE_ANON_KEY: Boolean(supabaseAnonKey),
  });
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    // ✅ keeps session in localStorage
    persistSession: true,
    autoRefreshToken: true,

    // ✅ IMPORTANT: always parse login results from URL (code or hash)
    detectSessionInUrl: true,

    // ✅ IMPORTANT: use PKCE so you get ?code=... not #access_token=...
    flowType: "pkce",
  },
});